import React from "react";
import styled from "styled-components";

// components
import FormSelectDialog from "../index";
import Control, { ControlStyled } from "../components/Control";
import IconCaret from "../components/IconCaret";
import Dialog from "../components/Dialog";

// styles
import colors from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
export const FormSelectDialogCaretStyled = styled.div`
    height: 100%;

    ${ControlStyled} {
        border: 3px solid ${colors.primary.diamond};
        padding-left: ${convertPxToRem(12)};
        padding-right: ${convertPxToRem(12)};
        background-color: ${colors.primary.snow};

        &:hover,
        &:active {
            background-color: ${colors.primary.diamond};
        }
    }
`;

// component
export const FormSelectDialogCaret = ({ className, ...rest }) => {
    return (
        <FormSelectDialogCaretStyled className={className}>
            <FormSelectDialog {...rest}>
                <Dialog>
                    <Control>
                        <IconCaret />
                    </Control>
                </Dialog>
            </FormSelectDialog>
        </FormSelectDialogCaretStyled>
    );
};

export default FormSelectDialogCaret;

import PropTypes from "prop-types";

// prop-types
FormSelectDialogCaret.propTypes = {
    className: PropTypes.string
};
